
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fabrics/[slug]",
      function () {
        return require("private-next-pages/fabrics/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fabrics/[slug]"])
      });
    }
  